/* HFB accessibility remediation - Phase 3 + Phase 4 (#281650684) + Phase 5 (#281651084).
   Companion to assets/hfb-a11y.css (Phase 1 + Phase 2 + Phase 4).

   Every failure fixed here is on a control that ONLY exists once JavaScript has
   run - the cart dropdown toggle, the product zoom button, the Slick galleries,
   the size-guide panel and the Wishlist Engine widget - so repairing them from
   JS costs nothing that a Liquid edit would have preserved, and it keeps the
   whole remediation in two carryable files. This store rotates themes weekly;
   a fix spread across six snippets cannot be carried onto the next one.

   Remove this file + its <script> in layout/theme.liquid to roll Phase 3 and
   Phase 4 back together. Phase 5 is section 15 only. Phase 4 is the
   Lighthouse-accessibility follow-up:
   sections 8-14 below. Everything in Phase 3 is names, roles and tab order and
   is invisible to a sighted mouse user; Phase 4 adds three things that DO
   render - see sections 12 (announcement bar, repaints the same colour), 13
   (Redo popup, recoloured to the site's own sage) and hfb-a11y.css section 18
   (touch-target sizes). */
(function () {
  'use strict';

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  /* "/collections/new" -> "Shop New". Used only for links whose entire content
     is empty, where the destination is the only truthful name available. */
  function nameFromHref(href) {
    var path = String(href || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
    var seg = path.split('/').filter(Boolean).pop() || '';
    var words = seg.replace(/[-_]+/g, ' ').trim();
    if (!words) return '';
    words = words.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    return path.indexOf('/collections/') === 0 ? 'Shop ' + words : words;
  }

  /* A div given role="button" must also be operable from the keyboard, or the
     role is a lie. Enter/Space forward to the element the vendor binds click on. */
  function activateOnKey(el) {
    if (el.getAttribute('data-hfb-a11y-keys')) return;
    el.setAttribute('data-hfb-a11y-keys', '1');
    el.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
      ev.preventDefault();
      (el.querySelector('.wishlist-engine-button') || el).click();
    });
  }

  /* Making something focusable INSIDE an aria-hidden subtree creates a control a
     keyboard can reach but a screen reader refuses to announce (WCAG 4.1.2) -
     which is exactly what a carousel's off-screen clones are. Slick already
     parks its own links at -1 in there; anything we add has to follow suit, and
     flip back to 0 when the slide rotates into view. */
  function setFocusable(el) {
    setAttr(el, 'tabindex', el.closest('[aria-hidden="true"]') ? '-1' : '0');
  }

  function each(selector, fn) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i]);
  }


  /* Redo renders its marketing form, popup and chat inside OPEN shadow roots.
     An external stylesheet cannot cross that boundary - but script can, and an
     author !important declaration still beats the inline styles Redo writes. */
  function eachRedoShadowRoot(fn) {
    var hosts = document.querySelectorAll('[id^="redo-"]');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) { try { fn(hosts[i].shadowRoot); } catch (e) { /* vendor DOM */ } }
    }
  }

  /* A heading's LEVEL is what a screen-reader user navigates by, and skipping
     one breaks the outline (WCAG 1.3.1). aria-level restates the level without
     touching the tag, so every h1..h6 rule the theme relies on still matches
     and nothing moves on screen. Only ever pulls a level UP to close a gap;
     it never pushes one down, and it never touches the first heading. */
  function normalizeHeadingLevels() {
    var nodes = document.querySelectorAll('h1,h2,h3,h4,h5,h6');
    var prev = 0;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      /* Hidden headings are not in the outline a checker or a screen reader
         reads, so they must not shift the sequence either. */
      if (!el.offsetParent && !el.getClientRects().length) continue;
      var natural = Number(el.tagName.charAt(1));
      var level = (prev && natural > prev + 1) ? prev + 1 : natural;
      if (level !== natural) setAttr(el, 'aria-level', String(level));
      else if (el.hasAttribute('aria-level')) el.removeAttribute('aria-level');
      prev = level;
    }
  }

  /* Section 5 below parks the SLIDE element itself at tabindex="-1", but an
     ancestor's tabindex does NOT remove its descendants from the tab order.
     Slick's off-screen clones therefore keep their own <a class="swatch">
     colour links natively focusable, so a keyboard user still lands on a link
     the screen reader is told does not exist (WCAG 4.1.2 / 1.3.1). Section 15
     parks every focusable DESCENDANT of a rendered aria-hidden subtree, and
     restores each one to exactly the value it had when the slide rotates back
     into view - so nothing that should be reachable loses its place.
     A display:none subtree (the closed quick-view dialogs) is skipped: it is
     not focusable in the first place, and sweeping it is what over-reported
     21 nodes where only 6 were real. */
  var HFB_FOCUSABLE = 'a[href],area[href],button,input,select,textarea,summary,iframe,object,embed,' +
    'audio[controls],video[controls],[contenteditable="true"],[tabindex]';

  function isRendered(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function containFocusInAriaHidden() {
    each('[aria-hidden="true"]', function (host) {
      if (!isRendered(host)) return;
      var nodes = host.querySelectorAll(HFB_FOCUSABLE);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        /* Already out of the tab order - slick parks its own controls at -1.
           Leave them alone so we never hand one back at the wrong value. */
        if (el.getAttribute('tabindex') === '-1') continue;
        if (el.getAttribute('data-hfb-ti') === null) {
          var prior = el.getAttribute('tabindex');
          el.setAttribute('data-hfb-ti', prior === null ? '' : prior);
        }
        setAttr(el, 'tabindex', '-1');
      }
    });

    /* Anything we parked that is no longer inside a hidden subtree goes back to
       precisely its prior state - an absent tabindex stays absent. */
    each('[data-hfb-ti]', function (el) {
      if (el.closest('[aria-hidden="true"]')) return;
      var prior = el.getAttribute('data-hfb-ti');
      el.removeAttribute('data-hfb-ti');
      if (prior === '') el.removeAttribute('tabindex');
      else setAttr(el, 'tabindex', prior);
    });
  }

  function fix() {
    /* 1. Icon-only header dropdown toggles (cart, account) have no accessible
          name - WCAG 4.1.2. They already carry the tooltip text they display on
          hover, so that is the name the sighted user gets; reuse it verbatim. */
    each('.tt-dropdown-toggle[data-tooltip]', function (el) {
      if (!el.getAttribute('aria-label')) setAttr(el, 'aria-label', el.getAttribute('data-tooltip'));
      /* An <a> with no href is not a link, so aria-label is PROHIBITED on it
         (this is the "My Account" toggle). Give it the role it actually plays. */
      if (el.tagName === 'A' && !el.hasAttribute('href')) {
        setAttr(el, 'role', 'button');
        if (el.getAttribute('tabindex') === null) setAttr(el, 'tabindex', '0');
        activateOnKey(el);
      }
    });

    /* 2. Product-gallery zoom button: an <i> icon and nothing else. */
    each('.tt-btn-zomm', function (el) {
      if (!el.getAttribute('aria-label')) setAttr(el, 'aria-label', 'Zoom product image');
    });

    /* 3. Links whose entire content is empty - the homepage banner's full-slide
          click overlay (the hero has no text and no <img>, so a screen reader
          currently gets nothing at all from it) and the search pagination
          arrows. WCAG 2.4.4 / 4.1.2. */
    each('.slidelink > a[href]', function (el) {
      if (el.textContent.trim() || el.getAttribute('aria-label')) return;
      var name = nameFromHref(el.getAttribute('href'));
      if (name) setAttr(el, 'aria-label', name);
    });
    each('a.btn-pagination', function (el) {
      if (el.textContent.trim() || el.getAttribute('aria-label')) return;
      var cls = ' ' + el.className + ' ';
      if (cls.indexOf(' btn-next ') > -1) setAttr(el, 'aria-label', 'Next page');
      else if (cls.indexOf(' btn-prev ') > -1) setAttr(el, 'aria-label', 'Previous page');
    });

    /* 4. Slick wraps a <ul> gallery's <li>s in two <div>s, so the list loses its
          required parent/child relationship (WCAG 1.3.1). Marking the injected
          wrappers presentational restores it without moving any markup. */
    each('ul.slick-slider .slick-list, ul.slick-slider .slick-track', function (el) {
      setAttr(el, 'role', 'presentation');
    });
    /* Marking the wrappers presentational restores the <li>s' required parent,
       but axe's `list` rule reads the DOM children, not the ARIA tree - so the
       list and its items also get their roles stated outright. Measured: with
       the wrappers alone, `listitem` passed and `list` still failed. */
    each('ul.slick-slider', function (el) {
      setAttr(el, 'role', 'list');
    });
    each('ul.slick-slider > .slick-list li.slick-slide', function (el) {
      setAttr(el, 'role', 'listitem');
    });

    /* 5. Slides Slick has hidden from assistive tech are still left in the tab
          order (aria-hidden="true" + tabindex="0") - a keyboard user focuses
          something a screen reader refuses to announce. WCAG 4.1.2. */
    each('.slick-slide[aria-hidden="true"]', function (el) {
      if (el.getAttribute('tabindex') === '0') setAttr(el, 'tabindex', '-1');
    });

    /* 6. The size-guide panel scrolls but cannot be reached or scrolled by
          keyboard. WCAG 2.1.1. */
    each('.size-guide-content', function (el) {
      setFocusable(el);
      setAttr(el, 'role', 'group');
      if (!el.getAttribute('aria-label')) setAttr(el, 'aria-label', 'Size guide');
    });

    /* 7. Wishlist Engine renders its button as a bare <div aria-label="Add to
          Wishlist"> with NO focusable element inside it, so (a) aria-label is
          prohibited on a div with no role, and (b) the control cannot be reached
          or operated by keyboard AT ALL (WCAG 2.1.1, Level A). Giving it the
          button role plus a real key handler fixes the barrier, not just the
          audit line. aria-pressed mirrors the widget's own data-added state so
          the toggle is perceivable. */
    each('div.wishlist-engine[aria-label]', function (el) {
      setAttr(el, 'role', 'button');
      setFocusable(el);
      setAttr(el, 'aria-pressed', el.getAttribute('data-added') === 'true' ? 'true' : 'false');
      activateOnKey(el);
    });

    /* ================= Phase 4 - Lighthouse accessibility follow-up ==========
       Measured with Lighthouse 12.8.2 on the homepage: accessibility 86 mobile
       / 87 desktop before these. Each block below clears one failing audit. */

    /* 8. A product card's image link takes its accessible name from the <img>
          alt inside it. MOST carry the product title there and are fine - but a
          product whose image has no alt set in Shopify leaves the link with no
          name at all, and it is still in the tab order (WCAG 2.4.4 / 4.1.2,
          Lighthouse `link-name`). The card's own visible <h2 class="tt-title">
          is the truthful name and is exactly what a sighted user reads, so it
          is reused verbatim rather than composed from the URL.

          The name is set UNCONDITIONALLY rather than only on links that look
          unnamed, because neither "is it already named" test survives this
          page. The anchor's text contains the "New" / "Sale" badge spans, so a
          text test reports a name on every card and skips all of them. The
          img alt looks reliable and is not: Slick re-clones these slides and
          lazysizes swaps the <img>, so on any given paint a different two or
          three cards have no usable alt - the pair Lighthouse reported moved
          between every run (jones-top-green-ivory + winslow-top-denim, then
          kelsey-pullover-green + lenny-sweater-brown-blue). Naming every card
          from its own title is the only state-independent fix, and it is the
          same string the alt carries when the alt is there. */
    each('a.tt-img-parent', function (el) {
      if (el.getAttribute('aria-label')) return;
      var card = el.closest('.tt-product') || el.closest('.respimgsize');
      var title = card && card.querySelector('.tt-title');
      var name = title && title.textContent.trim();
      if (!name) {
        /* A cloned slide can be emptied of its title too. The product handle in
           the href is the last truthful source left. */
        var handle = /\/products\/([^/?#]+)/.exec(el.getAttribute('href') || '');
        name = handle
          ? handle[1].replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); })
          : nameFromHref(el.getAttribute('href'));
      }
      if (name) setAttr(el, 'aria-label', name);
    });

    /* 9. The mobile menu's Close control is written by vendor.min.js as
          <a href="#close">, and no element with id="close" exists anywhere on
          the site - so it reads as a broken in-page link (Lighthouse reports it
          under `skip-link`). Its sibling Back controls in the same generated
          menu already use href="#", and the handler dispatches on the CLASS
          (`hasClass('mm-close')`) and returns false, so the href is never read
          and this changes no behaviour. data-target is left intact. */
    each('a.mm-close[href="#close"]', function (el) {
      setAttr(el, 'href', '#');
    });

    /* 10. Judge.me's review carousel puts the product name in the link text and
           repeats it verbatim as the image's alt, so a screen reader announces
           the same product twice per slide (Lighthouse `image-redundant-alt`).
           Next to its own label the image is decorative. Only ever emptied when
           the two strings actually match. */
    each('a.jdgm-carousel-item__product > img[alt]', function (el) {
      var alt = (el.getAttribute('alt') || '').trim();
      if (alt && el.parentElement.textContent.trim() === alt) setAttr(el, 'alt', '');
    });

    /* 11. Heading levels skip - the footer's <h4>s follow an <h2>, with no <h3>
           between them (Lighthouse `heading-order`). */
    normalizeHeadingLevels();

    /* 12. The announcement bar is white text on .tt-top-panel's black, which
           renders at 21:1 - but every element between the text and that panel
           is transparent and .swiper-wrapper opens its own stacking context, so
           contrast checkers give up on the ancestor walk, fall back to the page
           cream and report 1.05:1 on text that is perfectly legible. Restating
           the panel's OWN computed background on the slides paints nothing new
           and makes the real ratio computable. Read from the panel rather than
           hard-coded, so a recoloured bar stays correct by itself. */
    var panel = document.querySelector('.tt-top-panel');
    var panelBg = panel && getComputedStyle(panel).backgroundColor;
    if (panelBg && panelBg !== 'transparent' && panelBg.indexOf('rgba(0, 0, 0, 0)') === -1) {
      each('.tt-top-panel .tt-infobar-slider .swiper-slide', function (el) {
        if (el.style.backgroundColor !== panelBg) el.style.backgroundColor = panelBg;
      });
    }

    /* 13. Redo's marketing popup and embedded form render white text on their
           own sage rgb(156,166,161) - 2.5:1, failing WCAG 1.4.3 - and no theme
           stylesheet can reach them because they live inside open shadow roots.
           Script can. The replacement is the SAME darkened sage Phase 2 applied
           across the rest of the store, so the popup matches the site instead
           of diverging from it. Only elements whose computed background is
           actually one of the failing sages are touched.
           The durable fix is one background-colour setting inside the Redo app;
           this is the part reachable from the theme. */
    eachRedoShadowRoot(function (root) {
      var nodes = root.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var bg = getComputedStyle(el).backgroundColor;
        if (bg === 'rgb(156, 166, 161)' || bg === 'rgb(156, 165, 160)' || bg === 'rgb(155, 166, 160)') {
          if (el.style.getPropertyPriority('background-color') !== 'important') {
            el.style.setProperty('background-color', '#6c7470', 'important');
          }
        }
      }

      /* 14. Redo's popup is a role="dialog" whose aria-labelledby points at a
              React-generated id that resolves to nothing, so the dialog has no
              accessible name (Lighthouse `aria-dialog-name`). Named from its own
              visible heading - never from invented copy. */
      var dialogs = root.querySelectorAll('[role="dialog"],[role="alertdialog"]');
      for (var d = 0; d < dialogs.length; d++) {
        var dlg = dialogs[d];
        if (dlg.getAttribute('aria-label')) continue;
        var ref = dlg.getAttribute('aria-labelledby');
        var refEl = ref && root.getElementById ? root.getElementById(ref) : null;
        if (refEl && refEl.textContent.trim()) continue;
        var src = dlg.querySelector('h1,h2,h3,h4,h5,h6') || dlg.querySelector('[data-arbiter="Text"]');
        var label = src && src.textContent.trim().slice(0, 80);
        if (label) setAttr(dlg, 'aria-label', label);
      }
    });

    /* 15. (Phase 5, ticket #281651084) Focus containment inside every rendered
           aria-hidden subtree. Runs LAST so it sees the tab order every section
           above has already set. */
    containFocusInAriaHidden();

  }

  /* Slick rewrites aria-hidden/tabindex on every slide change and the apps inject
     late, so a one-shot pass would not hold. Every write above is a no-op when the
     value already matches, so the observer settles instead of looping. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    var run = function () { queued = false; fix(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 16);
  }

  function start() {
    fix();
    new MutationObserver(schedule).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'tabindex', 'class', 'data-added', 'aria-label', 'data-tooltip']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
